export const TOOLTIP_NAMES = {
  DESELECT_OFFER: 'Please deselect offer to edit',
  CURRENT_PAY: 'What you are currently paying.',
  MAX_ROWS: 'Use up to 3 extra rows to show case what makes your plan unique',
};
